import { Action } from '@ngrx/store';

export const RESET_PASSWORD_SUCCESS = '[Customer] User Reset Password Success';

export class ResetPasswordSuccessAction implements Action {
  readonly type = RESET_PASSWORD_SUCCESS;

  constructor(public payload: { user: { key: string, identifier: string } }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/ResetPasswordSuccessAction.ts